module.exports = __webpack_public_path__ + "static/media/tribalCredit.bee733db.png";